var dl = require('datalib'),
    u  = {};

dl.extend(u, require('./format'));
module.exports = dl.extend(u, dl);


//////////////////
// WEBPACK FOOTER
// ./node_modules/vega/src/util/index.js
// module id = 634
// module chunks = 0